import { skipToken, useQuery } from "@tanstack/react-query";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { getVerifications } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const VERIFICATIONS_QUERY_KEY = "VERIFICATIONS";

export const getVerificationsQueryKey = (userID?: number) => [
  VERIFICATIONS_QUERY_KEY,
  { userID },
];

export const useVerificationsQuery = (userID?: number) => {
  // Verifications require an authenticated session. Gating on the logged-in
  // user prevents an unauthenticated refetch when the cache is cleared on
  // logout (which would otherwise 401).
  const loggedInUser = useLoggedInUser();

  return useQuery({
    queryKey: userID
      ? getVerificationsQueryKey(userID)
      : [VERIFICATIONS_QUERY_KEY],
    queryFn: loggedInUser
      ? processResponseWithApiProblemDetails(() => getVerifications(userID))
      : skipToken,
    refetchOnWindowFocus: false,
  });
};
